import React, { Component } from 'react';
import request from 'superagent'
import { restUrl } from 'config'
import ForumNameNotifier from 'components/ForumNameNotifier'
import 'css/forum.less'


export default class ForumContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      forums: []
    }
  }

  componentDidMount() {
    window.analytics.page('Forum')
    request
      .get(restUrl + 'forum')
      .end((err, res) => {
        if (!err) {
          this.setState({forums: res.body})
        }
      })
  }

  render() {
    if (this.state.forums.length === 0) return <div>Loading...</div>
    return (
      <div className='container-fluid forum-container'>
        <div className='row'>
          <div className='col-md-12 col-sm-12'>
            { (this.props.user.forumName === 'Anonymous better' || !this.props.user.forumName) && <ForumNameNotifier /> }
            { React.cloneElement(this.props.children, {forums: this.state.forums}) }
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/ForumContainer.js
 **/